import { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import service from "../utils/request";
import { convertFileSize } from "../utils/file";

export default function Progress({ uploadList, setUploadList }) {
    const timersRef = useRef({});

    useEffect(() => {
        Object.keys(uploadList).forEach((key) => {
            const item = uploadList[key];
            if (item && item.value === "100%" && !timersRef.current[key]) {
                timersRef.current[key] = setTimeout(() => {
                    setUploadList((prevUploadList) => {
                        const copy = { ...prevUploadList };
                        delete copy[key];
                        return copy;
                    });
                    delete timersRef.current[key];
                }, 2000);
            }
        });

        // Cleanup timers for items that no longer exist in uploadList
        Object.keys(timersRef.current).forEach((key) => {
            if (!uploadList[key]) {
                clearTimeout(timersRef.current[key]);
                delete timersRef.current[key];
            }
        });
    }, [uploadList, setUploadList]);

    useEffect(() => {
        return () => {
            Object.values(timersRef.current).forEach(clearTimeout);
        };
    }, []);

    async function handleUploadCloseAndCancel(key) {
        const itemToCancel = uploadList[key];

        const uploadListCopy = { ...uploadList };
        delete uploadListCopy[key];
        setUploadList(uploadListCopy);

        if (itemToCancel && itemToCancel.value !== '100%') {
            if (itemToCancel.cancelToken) {
                itemToCancel.cancelToken.cancel('The upload is canceled');
            }
            if (itemToCancel.id) {
                service.post("/filer/delete", [itemToCancel.id]).catch(err => {
                    console.error("Failed to clean up canceled file on backend:", err);
                });
            }
        }
    }

    if (!uploadList || Object.keys(uploadList).length === 0) {
        return null;
    }

    return (
        <div className="fixed z-50 w-96 right-4 bottom-4 max-h-[80vh] overflow-y-auto space-y-2">
            {Object.keys(uploadList).map((item) => (
                <div key={item} className="p-2 py-2 bg-white border rounded-md shadow">
                    <div className="flex items-center justify-between mb-1 text-lg text-left ">
                        {uploadList[item].name}
                        <FontAwesomeIcon
                            onClick={() => handleUploadCloseAndCancel(item)}
                            icon={faXmark}
                            className="cursor-pointer "
                        />
                    </div>
                    {uploadList[item].total !== undefined && (
                        <div className="text-xs text-gray-500 text-left mb-1.5">
                            {convertFileSize(uploadList[item].loaded || 0)} / {convertFileSize(uploadList[item].total)}
                        </div>
                    )}
                    <div className="w-full bg-gray-200 rounded-full">
                        <div
                            className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full duration-200"
                            style={{ width: uploadList[item].value === "0%" ? "5%" : uploadList[item].value }}
                        >
                            {uploadList[item].value}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}